/**
 * Brand Colors - Centralized color constants for Green Filter
 * Use these instead of hardcoding colors throughout the app
 */

export const COLORS = {
  // Brand Colors
  brandGreen: '#00ad23',
  brandGreenHover: '#008a1c',
  brandGreenDark: '#00901c',
  // WCAG AA-compliant green for text/buttons on white (or white text on this
  // green) - ~5.5:1 contrast, unlike brandGreen (~3:1) which fails 4.5:1 for
  // normal text and only barely clears 3:1 for large text.
  brandGreenAccessible: '#007a1a',
  brandBlack: '#000',
  brandWhite: '#fff',

  // Common Aliases (for convenience)
  white: '#fff', // Alias for brandWhite
  primary: '#00ad23', // Alias for brandGreen
  secondary: '#008a1c', // Alias for brandGreenHover
  darkGray: '#1a1a1a', // Alias for gray900
  lightGray: '#ebebeb', // Alias for gray500/border
  textGray: '#666', // Alias for textSecondary

  // Alert/Status Colors
  red: '#ff0000',
  redHover: '#cc0000',
  redGradientStart: '#ff4444',
  redGradientEnd: '#ee3355',
  error: '#f44336',
  errorDark: '#e53935',
  success: '#4caf50',
  successDark: '#45a049',
  successAlt: '#00b92d',

  // Neutral Colors
  gray100: '#fafafa',
  gray200: '#f8f8f8',
  gray300: '#f0f0f0',
  gray400: '#e8e8e8',
  gray500: '#ebebeb',
  gray600: '#666',
  gray700: '#555',
  gray800: '#333',
  gray900: '#1a1a1a',
  gray999: '#111',

  // Text Colors
  textPrimary: '#1a1a1a',
  textSecondary: '#666',
  textMuted: '#999',

  // Background Colors
  bgWhite: '#fff',
  bgGray: '#fafafa',
  bgDark: '#f8f8f8',

  // Border Colors
  border: '#ebebeb',
  borderGray: '#d0d0d0',
  borderLight: '#f0f0f0',
  borderDark: '#e8e8e8',

  // Sale/Discount Colors
  discountRed: '#ff6b6b',
  discountRedEnd: '#ee5a6f',
  saveText: '#ff6b6b',
  stockWarning: '#ff9800',
} as const;

export type ColorName = keyof typeof COLORS;
